import { render, staticRenderFns } from "./ProductCardDefaultMultiple.vue?vue&type=template&id=4c06ffdd&scoped=true&"
import script from "./ProductCardDefaultMultiple.vue?vue&type=script&lang=js&"
export * from "./ProductCardDefaultMultiple.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardDefaultMultiple.vue?vue&type=style&index=0&id=4c06ffdd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06ffdd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCardDefault: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ProductCard/ProductCardDefault.vue').default})
